<template>
  <div
    class="flex flex-col items-center py-10"
    :style="`background-color:${bgColor}`"
  >
    <div class="py-5 space-y-5 w-11/12 lg:w-9/12">
      <div class="text-xl font-bold">
        <slot name="title"></slot>
      </div>
      <div
        class="grid gap-8 grid-cols-1"
        :class="[tileView === 'grid' ? 'md:grid-cols-2 lg:grid-cols-3' : '']"
      >
        <slot name="courses"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Courses',
  props: {
    tileView: {
      default: 'list',
    },
    bgColor: {},
  },
};
</script>